/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Privacylist_Onlysubscribed2Inputs */

const id_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami hanya mengirim notifikasi yang Anda langgani`)
};

const ms_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami hanya menghantar pemberitahuan yang anda langgan`)
};

const da_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi sender kun notifikationer du har abonneret på`)
};

const de_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir senden nur Benachrichtigungen, die Sie abonniert haben`)
};

const en_us2_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We only send notifications you've subscribed to`)
};

const es_es2_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo enviamos las notificaciones a las que te has suscrito`)
};

const es_mx2_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo enviamos las notificaciones a las que te has suscrito`)
};

const fil_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagpapadala lang kami ng mga notipikasyong ni-subscribe mo`)
};

const fr_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous n'envoyons que les notifications auxquelles vous êtes abonné`)
};

const it_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviiamo solo le notifiche a cui ti sei iscritto`)
};

const hu_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csak azokról a témákról küldünk értesítést, amelyekre feliratkoztál`)
};

const nl_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We sturen alleen meldingen waarop je je hebt geabonneerd`)
};

const no_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi sender bare varsler du har abonnert på`)
};

const pl_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłamy tylko powiadomienia, które zasubskrybowałeś`)
};

const pt_br2_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviamos apenas notificações nas quais você se inscreveu`)
};

const pt_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas enviamos notificações a que subscreveu`)
};

const ro_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trimitem doar notificările la care te-ai abonat`)
};

const fi_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetämme vain ilmoituksia, joihin olet tilannut`)
};

const sv_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi skickar endast notiser du prenumererat på`)
};

const vi_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chúng tôi chỉ gửi thông báo bạn đã đăng ký`)
};

const tr_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca abone olduğunuz bildirimleri göndeririz`)
};

const cs_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posíláme pouze oznámení, která jste si předplatili`)
};

const bg_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изпращаме само известия, за които сте се абонирали`)
};

const ru_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы отправляем только те уведомления, на которые вы подписались`)
};

const uk_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ми надсилаємо лише ті сповіщення, на які ви підписалися`)
};

const ar_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نرسل فقط الإشعارات التي اشتركت فيها`)
};

const hi_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम केवल वे सूचनाएँ भेजते हैं जिनकी आपने सदस्यता ली है`)
};

const th_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เราจะส่งเฉพาะการแจ้งเตือนที่คุณสมัครรับแล้วเท่านั้น`)
};

const ja_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購読した通知のみを送信します`)
};

const zh_cn2_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们仅发送您已订阅的通知`)
};

const zh_hant1_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們僅傳送您已訂閱的通知`)
};

const ko_notifications_privacylist_onlysubscribed2 = /** @type {(inputs: Notifications_Privacylist_Onlysubscribed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독한 알림만 전송합니다`)
};

/**
* | output |
* | --- |
* | "We only send notifications you've subscribed to" |
*
* @param {Notifications_Privacylist_Onlysubscribed2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_privacylist_onlysubscribed2 = /** @type {((inputs?: Notifications_Privacylist_Onlysubscribed2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Privacylist_Onlysubscribed2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "ms") return ms_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "da") return da_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "de") return de_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "en-US") return en_us2_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "es-ES") return es_es2_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "fil") return fil_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "fr") return fr_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "it") return it_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "hu") return hu_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "nl") return nl_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "no") return no_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "pl") return pl_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "pt") return pt_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "ro") return ro_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "fi") return fi_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "sv") return sv_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "vi") return vi_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "tr") return tr_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "cs") return cs_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "bg") return bg_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "ru") return ru_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "uk") return uk_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "ar") return ar_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "hi") return hi_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "th") return th_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "ja") return ja_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_privacylist_onlysubscribed2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_privacylist_onlysubscribed2(inputs)
	return ko_notifications_privacylist_onlysubscribed2(inputs)
});
export { notifications_privacylist_onlysubscribed2 as "notifications.privacyList.onlySubscribed" }